import { useQuery } from '@tanstack/react-query';
import { getInsuranceChart } from '../api';
import { INSURANCE_QUERY_KEY } from '../constants';
import { InsuranceFilterParams } from '../model';

export const useInsuranceChart = (params?: InsuranceFilterParams) => {
  return useQuery({
    queryKey: [INSURANCE_QUERY_KEY.CHART, params],
    queryFn: () => getInsuranceChart(params),
    enabled: Boolean(params?.year),
  });
};
